import React from "react";
import { House, Grid, Collection, BoxArrowRight } from "react-bootstrap-icons";
import "./sidebar.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

export function Sidebar({ collapsed, isMobile, isOpen, onToggle }) {
  const getUserData = JSON.parse(localStorage.getItem("user"));

  const { logout } = useAuth();

  // Close sidebar when clicking on overlay (mobile only)
  const handleOverlayClick = () => {
    if (isMobile) {
      onToggle();
    }
  };

  const navigate = useNavigate();

  const Logout = () => {
    logout();
    navigate("/login");
  };

  return (
    <>
      <div
        className={`sidebar 
        ${collapsed ? "collapsed" : ""} 
        ${isMobile && isOpen ? "show" : ""}
      `}
      >
        {/* Sidebar content remains same */}
        <div className="sidebar-header">
          <div className="logo-container">
            {collapsed ? (
              <img
                src="/images/logo.webp"
                alt="Logo"
                className="logo-collapsed"
              />
            ) : (
              <img
                src="/images/logo.webp"
                alt="Logo"
                className="logo-expanded"
              />
            )}
          </div>
        </div>

        <ul className="nav flex-column sidebar-nav">
          <li className="nav-item">
            <a className="nav-link" href="/">
              <House className="sidebar-icon" />
              {!collapsed && <span>Home</span>}
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/create">
              <Grid className="sidebar-icon" />
              {!collapsed && <span>Apps</span>}
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/admin/category">
              <Collection className="sidebar-icon" />
              {!collapsed && <span>Categories</span>}
            </a>
          </li>

          {/* All-Apps - Only Admin */}
          {getUserData?.user?.role === "admin" && (
            <li className="nav-item">
              <a className="nav-link" href="/apps">
                <Collection className="sidebar-icon" />
                {!collapsed && <span>All-Apps</span>}
              </a>
            </li>
          )}
        </ul>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={Logout}>
            <BoxArrowRight className="sidebar-icon" />
            {!collapsed && <span>Logout</span>}
          </button>
        </div>
      </div>

      {/* Mobile overlay */}
      {isMobile && isOpen && (
        <div className="sidebar-overlay" onClick={handleOverlayClick}></div>
      )}
    </>
  );
}
